var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgIconScreenEnable(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#fff",
    strokeWidth: 2
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M12 20h4m-4 0H8m4 0v-4m0 0H5a1 1 0 01-1-1V6a1 1 0 011-1h14a1 1 0 011 1v9a1 1 0 01-1 1h-7z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconScreenEnable;